import { createElement, forwardRef, type HTMLAttributes } from 'react';

/** The `<mat-select>` host element (JSX has no typing for it), so element selectors and Material's rules match. */
export const MatSelectHost = forwardRef<HTMLElement, HTMLAttributes<HTMLElement>>(function MatSelectHost(props, ref) {
  return createElement('mat-select', { ...props, ref });
});
